import type { DocMigration } from "../docMigration";

// eslint-disable-next-line @typescript-eslint/naming-convention
const migration_0_0_338: DocMigration = {
  maxSchemaVersion: "0.0.338",
  description: "Fix any malformed DocAuxOptionSet object in auxOptionSets table",
  apply(json: any) {
    for (const optionSetId in json.auxOptionSets) {
      const auxOptionSet = json.auxOptionSets[optionSetId];

      if (auxOptionSet.entityType !== "AUX_OPTION_SET") {
        const optionSet = json.optionSets?.[optionSetId];
        if (optionSet) {
          auxOptionSet.id = optionSetId;
          auxOptionSet.name = optionSet?.name ?? "";
          auxOptionSet.sortIndex = 0;
          auxOptionSet.entityType = "AUX_OPTION_SET";
        } else {
          // no corresponding option set, therefore delete the aux option set
          delete json.auxOptionSets[optionSetId];
        }
      }
    }

    return json;
  },
};

export default migration_0_0_338;
